import axios from 'axios'

// axios.defaults.timeout = 180000
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

const service = axios.create({
  // axios中请求配置有baseURL选项,表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: 'http://sh.havospark.cn:9800',
  // 超时
  timeout: 180000
})

service.interceptors.request.use(config => {
  // 是否需要设置 token
  const token = window.sessionStorage.getItem('token') || ''
  config.headers['token'] = token // 让每个请求携带自定义token 请根据实际情况自行修改
  const userId = window.sessionStorage.getItem('userId') || 0
  config.headers['userId'] = userId
  config.headers['clientFlag'] = 1
  let session = window.sessionStorage.getItem('session') || ''
  if (session !== undefined) {
    config.headers['session'] = session
  }
  return config
},
error => {
  Promise.reject(error)
})

export default service
